import { ApiError } from '../../api/client'
import { NfcWriteError, type NfcErrorCode } from './types'

/** Friendly Spanish message with a next step for every writer error code. */
export const NFC_ERROR_MESSAGES: Record<NfcErrorCode, string> = {
  NO_READER: 'No se detecta un lector NFC. Conectar el lector al equipo e intentar de nuevo.',
  NO_TAG: 'No hay ninguna etiqueta sobre el lector. Acercar una etiqueta e intentar de nuevo.',
  TAG_LOST: 'Se perdió el contacto con la etiqueta durante la escritura. Mantenerla quieta sobre el lector y repetir la operación.',
  UNSUPPORTED_TAG: 'La etiqueta no es compatible: se requiere una NTAG216. Usar otra etiqueta.',
  AUTH_FAILED: 'La etiqueta ya está protegida con otra contraseña y no se puede reescribir desde esta aplicación. Usar una etiqueta nueva o consultar al administrador.',
  TIMEOUT: 'Se agotó el tiempo de espera. Acercar la etiqueta y repetir la operación.',
  NO_NFC: 'Este dispositivo no tiene NFC. Usar un teléfono con NFC o el lector de escritorio.',
  NFC_DISABLED: 'El NFC está desactivado. Activarlo en los ajustes del dispositivo e intentar de nuevo.',
  INVALID_REQUEST: 'La solicitud de escritura no es válida. Recargar la página e intentar de nuevo; si persiste, avisar al administrador.',
  BRIDGE_UNAVAILABLE: 'Se perdió la conexión con el programa NFC. Verificar que esté abierto e intentar de nuevo.',
  UNKNOWN: 'No se pudo escribir la etiqueta. Intentar de nuevo; si persiste, avisar al administrador.',
}

const API_MESSAGES: Record<string, string> = {
  tag_revoked: 'Esta etiqueta está revocada y no se puede escribir. Registrar una etiqueta nueva.',
  tag_not_nfc: 'Solo las etiquetas NFC se pueden escribir. Esta etiqueta es un código QR.',
  permission_denied: 'Solo un administrador o ingeniero puede escribir etiquetas.',
  public_base_url_not_configured: 'La dirección pública del sistema no está configurada. Avisar al administrador.',
  throttled: 'Demasiados intentos seguidos. Esperar un momento e intentar de nuevo.',
}

/** Message for whatever failed between "click" and "result". */
export function describeWriteFailure(error: unknown): string {
  if (error instanceof NfcWriteError) return NFC_ERROR_MESSAGES[error.code]
  if (error instanceof ApiError) {
    if (API_MESSAGES[error.code]) return API_MESSAGES[error.code]
    if (error.status === 429) return API_MESSAGES.throttled
    if (error.status === 0) return error.message
  }
  return NFC_ERROR_MESSAGES.UNKNOWN
}
